import { render, staticRenderFns } from "./radish-choose-dialog.vue?vue&type=template&id=2f66f2ba&"
import script from "./radish-choose-dialog.vue?vue&type=script&lang=js&"
export * from "./radish-choose-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "radish-choose-dialog.vue"
export default component.exports